import { Col, Row } from "antd";
import VehicleDetails from "../../VehicleDetails";
import List from "./List";

const RideHistory = ({ onChangeVehicle, vehicle }) => {
  return (
    <Row gutter={[16, 16]} className="test-ride-history-page" data-testid="test-ride-history">
      <Col xs={24} sm={24} md={24} lg={24} xl={5}>
        <VehicleDetails onChangeImei={onChangeVehicle} imei={vehicle} />
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={19}>
        <List />
      </Col>
    </Row>
  );
};

export default RideHistory;
